import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=0efa3a0d&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=0efa3a0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efa3a0d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0efa3a0d')) {
      api.createRecord('0efa3a0d', component.options)
    } else {
      api.reload('0efa3a0d', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=0efa3a0d&scoped=true&", function () {
      api.rerender('0efa3a0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2m5Qwtv0T70tC/JS/comp/PopupDialog.vue"
export default component.exports